module.exports = __webpack_public_path__ + "static/media/dnd_cover.ece1fd22.jpg";